import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const restrictionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRestrictions: builder.query({
      query: (industryId) => {
        const id = industryId ? industryId : 0
        return `/industries/${id}/publisher_restrictions`
      },
      providesTags: (result, error, arg) => [{ type: 'Restriction', id: `${arg}LIST` }],
    }),
    createRestriction: builder.mutation({
      query: (restriction) => ({
        url: `/industries/${restriction.industryId}/publisher_restrictions`,
        method: 'POST',
        body: restriction
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Restriction', id: `${arg.industryId}LIST` },
        'Stream',
        'DataVendorStream'
      ],
    }),
    deleteRestriction: builder.mutation({
      query: ([industryId, restrictionId]) => ({
        url: `/industries/${industryId}/publisher_restrictions/${restrictionId}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Restriction', id: `${arg[0]}LIST` },
        'Stream',
        'DataVendorStream'
      ]
    }),
  }),
  overrideExisting: false
})

export const {
  useLazyGetRestrictionsQuery,
  useCreateRestrictionMutation,
  useDeleteRestrictionMutation
} = restrictionApiSlice
